export default __webpack_public_path__ + "static/media/drr.2338758a.jpg";